module.exports = __webpack_public_path__ + "static/media/pos_sale_panel.a527a17c.jpg";